import { Component, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { ESystemAccess, ESystemProfileList } from 'src/app/enum/EAccess';
import { SessionService } from 'src/app/shared/services/session.service';
import { AdministracionCarteraApiService } from '../services/administracion-cartera-api.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BagResponse } from '../models/bag';
import { BatchConfigListItem } from '../models/batch';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'app-admin-cartera-detail',
    templateUrl: './admin-cartera-detail.component.html',
    styleUrls: ['./admin-cartera-detail.component.scss']
})
export class AdminCarteraDetailComponent {
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    private readonly adminAccess: string = ESystemAccess.ADMINISTRACION_CARTERA_ADMIN;
    private readonly access: string[] = [
        ESystemAccess.ADMINISTRACION_CARTERA,
        ESystemProfileList.WEB
    ];

    isAdmin = false;

    id: string | null = null;
    detail: BagResponse | null = null;
    batchConfigs: BatchConfigListItem[] = []

    dataSource = new MatTableDataSource<BatchConfigListItem>();
    displayedColumns = ['modelo', 'frecuencia', 'destino'];

    isBatchConfigListLoading = false;

    constructor(
        private _alertsService: AlertService,
        private _apiService: AdministracionCarteraApiService,
        public dialog: MatDialog,
        private _router: Router,
        private _session: SessionService,
        private _route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        if (!this.checkAccess()) {
            this._router.navigate(['/request-access'])
            return;
        }

        this._route.paramMap.subscribe(params => {
            this.id = params.get('id');

            if (!this.id) return;

            this.getBagDetail(this.id);
            this.getBatchConfigs(this.id);
        });

    }

    getBatchConfigs(id: string) {
        this.isBatchConfigListLoading = true;

        this._apiService.getBatchConfigs(id).subscribe({
            next: (res) => {
                this.batchConfigs = res.batchConfigs || [];

                this.updateDataSource();

                this.isBatchConfigListLoading = false;
            },
            error: () => {
                this._alertsService.error("Ocurrió un error al intentar obtener los procesos asociados a la cartera");
                this.isBatchConfigListLoading = false;
            }
        });
    }

    getBagDetail(id: string) {
        this._apiService.getBagDetail(id).subscribe({
            next: (res) => {
                this.detail = res;
            },
            error: () => {
                this._alertsService.error("Ocurrió un error al intentar obtener el detalle de la cartera");
            }
        });
    }

    checkAccess() {
        if (this._session.getUserAccess().includes(this.adminAccess)) {
            this.isAdmin = true;
        }

        const hasAdminCarteraPermission = this._session.getUserAccess().includes(this.access[0]);
        const hasWebProfile = this._session.getUserProfileList().includes(this.access[1]);

        return hasAdminCarteraPermission && hasWebProfile;
    }

    onEdit() {
        this._router.navigate(['/administracion-cartera-editar', this.id]);
    }

    onAdmin() {
        this._router.navigate(['/administracion-cartera-procesos', this.id]);
    }

    onExecutions() {
        this._router.navigate(['/administracion-cartera-ejecuciones', this.id]);
    }

    goBack() {
        this._router.navigate(['/administracion-cartera'])
    }

    goToExecutions(process: BatchConfigListItem) {
        this._router.navigate(
            ['/administracion-cartera-ejecuciones', this.id],
            { queryParams: { modelId: process.batchTemplate.tag } }
        )
    }

    updateDataSource() {
        setTimeout(() => {
            this.dataSource = new MatTableDataSource<BatchConfigListItem>(this.batchConfigs);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        });
    }
}
